<template>
  <content-container :loadingStatus="isLoading" style="min-width: 905px">
    <div class="contract-list content-wrapper">
      <div class="page-header">{{ $t('emailHistory') }}</div>
      <email-history-search-component
        :hotel-list="hotelList"
        @onSearchButtonClick="onSearchButtonClick"
        @onResetButtonClick="onResetButtonClick">
      </email-history-search-component>
      <div class="table-email-history">
        <div style="margin-bottom: 10px">
          <span style="margin-right: 10px">Record per pages</span>
          <el-select v-model="itemPerPage" placeholder="Select" @change="getEmailHistoryList">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <el-table
          id="email-history-table"
          :data="emailHistoryList"
          @row-click="onSendingResultBtnClick"
          style="width: 100%"
          :row-style="{cursor: 'pointer'}"
          header-row-class-name="table-header-color">
          <el-table-column
            :label="$t('dateTime')"
            >
            <template slot-scope="scope">
              <b>{{bindDateTime(scope.row.createdAt)}}</b>
              <div style="margin-top: 10px">
                <font-awesome-icon style="font-size: 12px; vertical-align: inherit" icon="user"/>
                <span style="margin-left: 10px">{{scope.row.username}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('senderName')">
            <template slot-scope="scope">
              <b style="color: #2376e5;">{{scope.row.senderName}}</b>
              <div>({{getHotelName(scope.row.hotelId)}})</div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('sendTo')">
            <template slot-scope="scope">
              <div class="send-to"  v-if="!isEmptyList(scope.row.sendTo, 'isAllAgent') && scope.row.sendTo.isAllAgent">
                <b class="text-send-agent">{{$t('agent')}}: </b> {{ $t('all') }}
              </div>
              <div class="send-to"  v-if="!isEmptyList(scope.row.sendTo, 'agentList')">
                <b class="text-send-agent">{{$t('agent')}}: </b> {{bindAgent(scope.row.sendTo)}}
                <popover-view-more-item-component
                  v-if="scope.row.sendTo.agentList.length > 1"
                  :data-list="scope.row.sendTo.agentList"
                  list-type="agent">
                </popover-view-more-item-component>
              </div>
              <div class="send-to"  v-if="!isEmptyList(scope.row.sendTo, 'agentTypeList')">
                <b class="text-send-agent-type">{{$t('agentType')}}: </b>{{scope.row.sendTo.agentTypeList[0]}}
                <popover-view-more-item-component
                  v-if="scope.row.sendTo.agentTypeList.length > 1"
                  :data-list="scope.row.sendTo.agentTypeList"
                  list-type="agentType">
                </popover-view-more-item-component>
              </div>
              <div class="send-to" v-if="!isEmptyList(scope.row.sendTo, 'marketList')">
                <b class="text-send-market">{{$t('market')}}: </b>{{scope.row.sendTo.marketList[0]}}
                <popover-view-more-item-component
                  v-if="scope.row.sendTo.marketList.length > 1"
                  :data-list="scope.row.sendTo.marketList"
                  list-type="market">
                </popover-view-more-item-component>
              </div>
              <div class="send-to" v-if="!isEmptyList(scope.row.sendTo, 'toList')">
                <b class="text-send-to">{{$t('to')}}: </b>{{scope.row.sendTo.toList[0]}}
                <popover-view-more-item-component
                  v-if="scope.row.sendTo.toList.length > 1"
                  :data-list="scope.row.sendTo.toList"
                  list-type="to">
                </popover-view-more-item-component>
              </div>
              <div class="send-to"  v-if="!isEmptyList(scope.row.sendTo, 'ccList')">
                <b class="text-send-to">{{$t('cc')}}: </b>{{scope.row.sendTo.ccList[0]}}
                <popover-view-more-item-component
                  v-if="scope.row.sendTo.ccList.length > 1"
                  :data-list="scope.row.sendTo.ccList"
                  list-type="cc">
                </popover-view-more-item-component>
              </div>
              <div class="send-to"  v-if="!isEmptyList(scope.row.sendTo, 'bccList')">
                <b class="text-send-to">{{$t('bcc')}}: </b>{{scope.row.sendTo.bccList[0]}}
                <popover-view-more-item-component
                  v-if="scope.row.sendTo.bccList.length > 1"
                  :data-list="scope.row.sendTo.bccList"
                  list-type="bcc">
                </popover-view-more-item-component>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('subject')">
            <template slot-scope="scope">{{scope.row.subject}}</template>
          </el-table-column>
          <el-table-column
            :label="$t('detail')">
            <template slot-scope="scope">
              <div style="position: relative">
                <div>
                  <b>{{$t('type')}}: </b>
                  <el-tag v-if="scope.row.sendType === EMAIL_SEND_TYPE.CONTRACT"
                          size="small" effect="plain"
                          class="text-send-type-contract">
                    {{$t('contract')}}
                  </el-tag>
                  <el-tag v-if="scope.row.sendType === EMAIL_SEND_TYPE.SPECIAL_OFFER"
                          size="small" effect="plain"
                          class="text-send-type-special-offer">
                    {{$t('specialOffer')}}
                  </el-tag>
                  <el-tag v-if="scope.row.sendType === EMAIL_SEND_TYPE.GENERAL"
                          size="small" effect="plain"
                          class="text-send-type-general">
                    {{$t('general')}}
                  </el-tag>
                  <el-tag v-if="scope.row.sendType === EMAIL_SEND_TYPE.STOP_SALE"
                          size="small" effect="plain"
                          class="text-send-type-stop-sale">
                    {{$t('stopSale')}}
                  </el-tag>
                </div>
                <div v-if="isHasDetail(scope.row.detail, 'refCode')" class="text-overflow">
                  <b>{{$t('refCode')}}: </b>
                  <span :title="scope.row.detail.refCode">{{scope.row.detail.refCode}}</span>
                </div>
                <div v-if="isHasDetail(scope.row.detail, 'agentName')" class="text-overflow">
                  <b>{{$t('agentName')}}: </b>
                  <span :title="scope.row.detail.agentName">{{scope.row.detail.agentName}}</span>
                </div>
                <div v-if="isHasDetail(scope.row.detail, 'included')">
                  <b>{{$t('included')}}: </b>
                  {{bindIncluded(scope.row.detail.included)}}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px">
        <el-pagination
          background
          @current-change="changePage"
          :current-page="currentPage"
          layout="prev, pager, next"
          :page-size="itemPerPage"
          :total="totalListLength">
        </el-pagination>
      </div>
    </div>
    <popup-email-history-result-list-component
      :visible="isShowPopupEmailHistoryResult"
      :email-history="emailHistoryForResultList"
      :agent-list="agentList"
      :market-list="marketList"
      :agentTypeList="agentTypeList"
      @close="isShowPopupEmailHistoryResult = false">
    </popup-email-history-result-list-component>
  </content-container>
</template>

<script>
import i18nMessages from '@/translations/Email/ManageEmail/EmailHistory/Index.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import EmailHistorySearchComponent from '@/views/Email/ManageEmail/EmailHistory/components/EmailHistorySearchComponent.vue'
import PopoverViewMoreItemComponent from './components/PopoverViewMoreItemComponent.vue'
import PopupEmailHistoryResultListComponent from './components/PopupEmailHistoryResultListComponent'
import EmailApi from '@/api/email-api'
import { dateFormat } from '@/helpers/datetime'
import { EMAIL_SEND_TYPE, VUEX_EVENT } from '@/configs/constant'
import { get } from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { mapState } from 'vuex'
import AgentService from '@/services/agent-service'
import MarketApi from '@/api/setting/market-api'
import AgentTypeApi from '@/api/setting/agent-type-api'

library.add(faUser)

export default {
  name: 'EmailHistoryComponent',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: {
    ContentContainer,
    EmailHistorySearchComponent,
    PopoverViewMoreItemComponent,
    FontAwesomeIcon,
    PopupEmailHistoryResultListComponent
  },
  i18n: { messages: i18nMessages },
  data () {
    return {
      EMAIL_SEND_TYPE,
      isLoading: false,
      emailHistoryList: [],
      emailHistoryPageList: {},
      lastId: '',
      totalListLength: 1,
      currentPage: 1,
      itemPerPage: 10,
      filter: {
        startDate: '',
        endDate: '',
        hotelId: '',
        sendType: ''
      },
      hotelList: [],
      isShowPopupEmailHistoryResult: false,
      emailHistoryForResultList: {},
      agentList: [],
      agentTypeList: [],
      marketList: [],
      options: [{
        value: 10,
        label: '10'
      }, {
        value: 20,
        label: '20'
      }, {
        value: 50,
        label: '50'
      }, {
        value: 100,
        label: '100'
      }, {
        value: 999,
        label: 'All'
      }]
    }
  },
  computed: {
    ...mapState({
      emailHistoryListCurrentPage: state => state.contract.emailHistoryListCurrentPage,
      emailHistoryListLastId: state => state.contract.emailHistoryListLastId,
      emailHistoryPageListStore: state => state.contract.emailHistoryPageListStore
    })
  },
  created: async function () {
    this.isLoading = true
    await this.initDataList()
    this.isLoading = false
  },
  methods: {
    initDataList: async function () {
      this.stopLoading()

      try {
        const data = {
          filter: this.filter,
          lastId: (this.emailHistoryListCurrentPage > 1) ? this.emailHistoryListLastId : '',
          isFirstLoad: true
        }

        const result = await Promise.all([
          AgentService.getAgentList(),
          MarketApi.list(),
          AgentTypeApi.list(),
          EmailApi.historyList(data)
        ])

        this.agentList = result[0]
        this.marketList = result[1]
        this.agentTypeList = result[2]
        const emailHistoryResponse = result[3]

        this.hotelList = emailHistoryResponse.hotelList
        this.totalListLength = emailHistoryResponse.count
        this.options[4].value = emailHistoryResponse.count

        const emailHistoryListLength = emailHistoryResponse.emailHistoryList.length
        if (emailHistoryListLength > 0) {
          this.lastId = emailHistoryResponse.emailHistoryList[emailHistoryListLength - 1].id
        }

        this.emailHistoryList = [...emailHistoryResponse.emailHistoryList]
        this.emailHistoryPageList[this.currentPage] = [...emailHistoryResponse.emailHistoryList]

        if (this.emailHistoryListCurrentPage > 1) {
          this.currentPage = this.emailHistoryListCurrentPage

          this.emailHistoryPageList = Object.assign(this.emailHistoryPageList, this.emailHistoryPageListStore)
          this.emailHistoryList = [...this.emailHistoryPageList[this.currentPage]]

          this.lastId = this.emailHistoryList[this.emailHistoryList.length - 1].id
        }

        this.stopLoading()
      } catch (err) {
        this.alertError(err.message)
      }
    },
    changePage: function (page) {
      this.currentPage = page
      this.getEmailHistoryList()
    },
    getEmailHistoryList: async function () {
      this.startLoading()

      try {
        const data = {
          filter: this.filter,
          lastId: this.lastId,
          isFirstLoad: false,
          length: this.emailHistoryList.length * (this.currentPage - 1),
          limitItem: this.itemPerPage
        }
        const emailHistoryResponse = await EmailApi.historyList(data)
        const emailHistoryListLength = emailHistoryResponse.emailHistoryList.length
        this.totalListLength = emailHistoryResponse.count
        this.$store.dispatch(VUEX_EVENT.EMAIL_HISTORY.SET_EMAIL_HISTORY_LIST_LAST_ID, this.lastId)

        if (emailHistoryListLength > 0) {
          this.lastId = emailHistoryResponse.emailHistoryList[emailHistoryListLength - 1].id
        }

        this.emailHistoryList = emailHistoryResponse.emailHistoryList
        this.emailHistoryPageList[this.currentPage] = emailHistoryResponse.emailHistoryList
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    onSearchButtonClick: async function (filter) {
      this.filter = Object.assign({}, filter)
      this.lastId = ''
      this.currentPage = 1

      await this.getEmailHistoryList()
    },
    onResetButtonClick: async function (filter) {
      this.filter = Object.assign({}, filter)
      this.lastId = ''
      this.currentPage = 1

      await this.getEmailHistoryList()
    },
    bindDateTime: function (dateTime) {
      let dateStr = '-'

      if (dateTime !== '') {
        dateStr = dateFormat.long(dateTime)
      }

      return dateStr
    },
    getHotelName: function (hotelId) {
      const hotelData = this.hotelList.find(hotel => hotel.id === hotelId)
      const hotelName = get(hotelData, 'name', '-')

      return hotelName
    },
    bindAgent: function (sendTo) {
      const agentList = get(sendTo, 'agentList', [])
      const firstAgentName = get(agentList, '[0]', '-')

      return firstAgentName
    },
    isEmptyList: function (objData, key) {
      const dataList = get(objData, `${key}`, [])
      return (dataList.length === 0)
    },
    isHasDetail: function (obj, key) {
      const data = get(obj, `${key}`, '')
      return (data !== '')
    },
    bindIncluded: function (includedData) {
      let includedList = []

      if (includedData.primaryContactPerson === true) {
        includedList.push('Primary')
      }

      if (includedData.secondaryContactPerson === true) {
        includedList.push('Secondary')
      }

      if (includedData.agentEmail === true) {
        includedList.push('Agent Email')
      }

      if (includedData.stopSaleContactPerson === true) {
        includedList.push('Stop Sale')
      }

      const includedStr = (includedList.length > 0) ? includedList.join(' / ') : '-'
      return includedStr
    },
    onSendingResultBtnClick: function (emailHistory) {
      this.emailHistoryForResultList = emailHistory
      this.isShowPopupEmailHistoryResult = true
    }
  }
}
</script>

<style scoped>
  .send-to {
    padding-bottom: 5px;
  }
  .text-send-to {
    color: #409EFF;
  }
  .text-send-agent {
    color: #e6a23c;
  }
  .text-send-agent-type {
    color: #6a6d74;
  }
  .text-send-market {
    color: #67c23a;
  }

  #email-history-table{
    width: 100%;
    border: 1px solid #dddddd;
    border-radius: 5px;
  }

  .text-send-type-contract {
    color: #ffffff !important;
    font-size: 14px !important;
    background: #409EFF !important;
    border-color: #409EFF !important;
    margin-right: 5px
  }
  .text-send-type-special-offer {
    color: #ffffff !important;
    font-size: 14px !important;
    background: #f6ad16 !important;
    border-color: #f6ad16 !important;
    margin-right: 5px
  }
  .text-send-type-general {
    color: #ffffff !important;
    font-size: 14px !important;
    background: #67c23a !important;
    border-color: #67c23a !important;
    margin-right: 5px
  }
  .text-send-type-stop-sale {
    color: #ffffff !important;
    font-size: 14px !important;
    background: #F56C6C !important;
    border-color: #F56C6C !important;
    margin-right: 5px
  }
  .el-tag {
    border-radius: 25px !important;
  }

  .text-overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .sending-result-btn {
    position: absolute;
    z-index: 10;
    top: 20px;
    right: 20px
  }
  .overlay-sending-result-btn {
    position: absolute;
    background: #000000;
    opacity: 0.5;
    height: 100%;
    width: 100%;
    z-index: 1
  }
  .sending-result-btn-container {
    position: absolute;
    top: 0px;
    right: 0px;
    height: 100%;
    width: 100%
  }
</style>
